interface IColumnActionProps {
    onClick: () => void;
}

export function ColumnActionDelete({ onClick }: IColumnActionProps) {
    return (
        <button className="btn p-0" type="button" onClick={onClick}>
            <i className="fa fa-trash" />
        </button>
    );
}
